module.exports = __webpack_public_path__ + "static/media/burger-menu.58f5b8bf.svg";